import { Component, Input, AfterContentChecked } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldsBlocQuestionV3 } from '../../../classes/question-fieldsBloc';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-fields-block-v3',
  templateUrl: './fields-block.component.html',
  styleUrls: ['./fields-block.component.scss'],
  standalone: false
})
export class FieldsBlockComponentV3
  extends QuestionBaseV3ComponentDirective
  implements AfterContentChecked
{
  @Input() question: FieldsBlocQuestionV3;
  @Input() formGroup: UntypedFormGroup;
  @Input() readonly: Boolean;
  @Input() color: string;

  ngAfterContentChecked() {
    const _this = this;
    const filledRepetitions = (
      this.question as FieldsBlocQuestionV3
    ).repetitions.filter(repetition => {
      const filledFields = repetition.filter(
        field => _this.formGroup.value[field.key]
      );
      repetition.showInForm = filledFields.length > 0;
      return repetition.showInForm;
    });
    if (filledRepetitions.length === 0) {
      (this.question as FieldsBlocQuestionV3).repetitions[0].showInForm = true;
    }
    const blockElements = document.getElementsByTagName(
      'bepatient-fields-block'
    );
    Array.from(blockElements).map(blockElement => {
      Array.from(blockElement.children).map(repetition => {
        this.setElementMargin(repetition);
      });
    });
  }

  setElementMargin(el) {
    const marginBottom =
      el.nextElementSibling && el.nextElementSibling.children.length > 0
        ? 'calc((var(--ion-margin) * 3) - 5px)'
        : '0px';
    el.style.setProperty('margin-bottom', marginBottom);
  }
}
